import {mapGetters} from 'vuex'
import Vue from 'vue'
import template from './index.pug'

export default Vue.extend({
  template: template(),

  data() {
    return {
      idm: Vue.language.getLanguage(),
      user: undefined,
      tokenValue: undefined,
      token: '',
      errorCode: '',
      dataR: '',
      dataP: '',
      urlAPI: Vue.store.getters['runtimeConfig/apiHost']
    }
  },
  created() {
    this.dataR = this.getRechargeData()
    this.user = this.currentUser
  },
  mounted() {
  // Call the function to create the script
    this.configScript().then(() => {
      // Once the script is loaded, it calls the form function
      this.callInSiteFormJSON()
    }).catch(error => {
      console.error('Error cargando el script:', error)
    })

    // Add the eventListener to get the data
    this.messageHandler = this.handleMessage.bind(this)
    window.addEventListener('storage', event => {
      if (event.key === 'rechargeDataS') {
        this.dataR = this.getRechargeData()
      }
    })

    window.addEventListener('message', this.messageHandler)
  },
  methods: {
    // Create the script for redsys
    async configScript() {
      return new Promise((resolve, reject) => {
        const base_url = `https://${this.dataR.payment_platform_base_url}`

        // Check if the script has already been added
        const existingScript = document.querySelector(`script[src="${base_url}"]`)
        if (existingScript) {
          resolve()

          return
        }

        // If it does not exist, the new script is created
        this.redsysScript = document.createElement('script')
        this.redsysScript.src = base_url
        this.redsysScript.onload = () => {
          resolve()
        }
        this.redsysScript.onerror = error => {
          console.error('Error al cargar el script', error)
          reject(error)
        }

        document.head.appendChild(this.redsysScript)
      })
    },

    // Create the insiteJSON object
    getInsiteJSON() {
      return {
        id: 'card-form',
        fuc: `${this.administrativeArea?.ds_merchant_code}`,
        terminal: `${this.administrativeArea?.ds_merchant_terminal}`,
        idioma: this.idm,
        order: this.dataR.merchant_order,
        estiloInsite: 'twoRows',
        estiloReducidoInsite: false,
        mostrarLogoInsite: true,
        buttonValue: '',
        styleButton: 'background-color: blue',
        styleBody: '',
        styleBox: '',
        styleBoxText: '',
        redsysScript: null
      }
    },

    callInSiteFormJSON() {
      const insiteJSON = this.getInsiteJSON()
      // Check if the form is charged
      if (typeof window.getInSiteFormJSON === 'function') {
        window.getInSiteFormJSON(insiteJSON)
      } else {
        console.error('getInSiteFormJSON no está definida en el contexto global después de cargar el script')
      }
    },

    // Handle the response from redsys and call to backend
    handleMessage(event) {
      storeIdOper(event, 'token', 'errorCode', this.merchantValidation)
      if (event?.data?.idOper) {
        this.merchantValidation(event)
      }
    },

    getRechargeData() {
      const data = localStorage.getItem('rechargeDataS')

      return data ? JSON.parse(data) : {}
    },

    async merchantValidation(event) {
      const previousToken = localStorage.getItem('tokenRedsys')

      if (event?.data?.idOper && event?.data?.idOper !== previousToken && this.dataR) {
        localStorage.setItem('tokenRedsys', event.data?.idOper)

        console.log(this.dataR, 'email')

        const data = {
          payment: {
            DS_MERCHANT_AMOUNT: this.dataR.amount,
            DS_MERCHANT_ORDER: this.dataR.merchant_order,
            DS_MERCHANT_IDOPER: event?.data?.idOper,
            DS_MERCHANT_TRANSACTIONTYPE: '0',
            RECHARGE_ID: this.dataR.id,
            EMAIL: this.user?.email || this.dataR?.email,
            _type: this.dataR._type,
            gateway: 'redsys',
            administrative_area_id: this.administrativeArea.id
          }
        }

        const url = `${this.urlAPI}/mobile_app/v1/payment/gateways`
        await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })

        // Limpia los datos después de la respuesta de backend
        localStorage.removeItem('rechargeDataS')
        localStorage.removeItem('tokenRedsys')
        this.dataR = ''
        event.data.idOper = null

        // Remove eventlistener
        window.removeEventListener('message', this.messageHandler)

        // Remove script
        this.redsysScript.remove()
        this.redsysScript = null
      }

      return true
    }
  }
})
